import * as React from "react";
import { Label as LabelPrimitive } from "radix-ui";

import { cn } from "./utils";

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        // leading-none + text-box cap-trim = the uniform control-centering
        // model shared with Button/Input/Select (PRD D4).
        "flex items-center gap-2 type-body leading-none [text-box:trim-both_cap_alphabetic] select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export { Label };
